import { registerPlugin } from '@capacitor/core';
import type { CellSignalPlugin } from '@/native/plugins/CellSignal/definitions';

const CellSignal = registerPlugin<CellSignalPlugin>('CellSignal', {
  web: () => import('./web').then((m) => new m.CellSignalWeb()),
});

export * from './definitions';
export { CellSignal };
